// extracted by mini-css-extract-plugin
export default {"container":"XsKQKv","tabs":"z0ErrC","tab":"wWJHfs","tab-container":"bSUV_7","tabContainer":"bSUV_7","active":"hf8gvP"};